import React, { Component, Fragment } from "react";
import Heading from "../../components/Header";
import BodyContent from "./BodyContent";
import Footer from "./Footer";

class LandingPage extends Component {
  render() {
    return (
      <Fragment>
        <Heading />
        <BodyContent />
        <Footer/>
      </Fragment>
    );
  }
}

export default LandingPage;



// WEBPACK FOOTER //
// ./src/views/Home/LandingPage.js